import React from 'react';
import { Section } from '../components/Section';
import { StartHere } from '../components/StartHere';
import { Atomizer } from '../components/home/Atomizer';
import { asset } from '../data/redesignAssets';
import { DEMO_URL } from '../data/links';
import { BRAND_ROWS, CHANGES, LIBRARY_SPLIT, LIBRARY_TOTAL, OWNERSHIP, SOURCES, TRUST, WHAT_IT_DOES, WHO_FOR } from '../data/home';
const TONE = {
  ink: 'var(--ink)',
  ink2: 'var(--ink-2)',
  amber: 'var(--amber)'
} as const;
export function Home() {
  return <>
      <Section n="01" label="Instruction governance" noTop contentClassName="hero-c" data-id="element-409" data-mp="24htrulnneyj5">
        <img className="swirl" src={asset('hero-swirl-home.svg')} alt="" width={432} height={446} style={{
        right: -129,
        top: 87
      }} data-id="element-410" data-mp="29f26ic9l8kfn" />
        <h1 className="h1" style={{
        maxWidth: 980
      }} data-id="element-411" data-mp="2dfm4fi1zjs2u">
          Your rules, your policies, your
          <br className="d" data-id="element-412" data-mp="3kv0jusbstsmo" /> know-how. Turned into instructions
          <br className="d" data-id="element-413" data-mp="3ovucfz06rvlw" /> your AI has to follow.
        </h1>
        <p className="lede" data-id="element-414" data-mp="30wjcmpo0ou4v">
          <span className="nowrap-d" data-id="element-415" data-mp="30vqda9re16wr">We take what your company already knows, your policies, your</span>
          <br className="d" data-id="element-416" data-mp="2vyq8s3a6sc7r" /> business rules, the judgment calls your best people make every day, and put it to work inside the platforms you
          already use. No rebuilding your workflow. Fewer mistakes, and better business outcomes.
        </p>
        <div className="btns" data-id="element-417" data-mp="2mzcyx9i5hlmi">
          <a className="btn btn-s" href={DEMO_URL} target="_blank" rel="noopener" data-id="element-418" data-mp="2hy714x9mv864">
            Book a demo
          </a>
          <a className="btn btn-o" href="#atomizer" data-id="element-419" data-mp="2d6fakmqh92fz">
            See it on a real document <span className="mono" data-id="element-420" data-mp="287cgtyfy6inb">↓</span>
          </a>
        </div>
      </Section>

      <section className="bleed sec-dk does" data-id="element-421" data-mp="239jan5en9on1">
        <div className="sec" style={{
        borderTop: 0
      }} data-id="element-422" data-mp="23alx914xp4x5">
          <div className="sec-m" data-id="element-423" data-mp="1z7xosuk4u00p">
            <div className="sec-l" data-id="element-424" data-mp="1z6weisaxxhk1">What it does</div>
          </div>
          <div className="does-g" data-id="element-425" data-mp="1u82yas49rcg6">
            {WHAT_IT_DOES.map(t => <div className="does-i" key={t} data-id="element-426" data-mp="1kkqqbobu2uip">
                <div className="t" data-id="element-427" data-mp="1kjxliswfqf37">{t}</div>
              </div>)}
          </div>
        </div>
      </section>

      <Section n="03" label="Instruction data" id="atomizer" data-id="element-428" data-mp="1ok7tgb3sffkp">
        <div className="hgroup" data-id="element-429" data-mp="1ankuy3w6shco">
          <h2 className="h2" style={{
          maxWidth: 900
        }} data-id="element-430" data-mp="1aodxeso44kp0">
            The rules already exist.
            <br data-id="element-431" data-mp="1flw4semheruw" />
            They’re just not instruction data.
          </h2>
          <p className="lede" data-id="element-432" data-mp="23cjen5fyjrk3">
            Your industry’s regulations, your policies, your best reviewer’s corrections, and the institutional knowledge nobody wrote
            down. Synthia turns all of it into instruction data: owned, versioned, portable, and yours.
          </p>
        </div>

        <Atomizer data-id="element-433" data-mp="1yj74g0c0znav" />

        <div className="flow" data-id="element-434" data-mp="1yinnomy434yf">
          <div data-id="element-435" data-mp="2ma2p8di2di8m">
            {SOURCES.map(s => <div className="srow" key={s.name} data-id="element-436" data-mp="2m8hy6xuykhfi">
                <div style={{
              display: 'flex',
              alignItems: 'baseline'
            }} data-id="element-437" data-mp="2r0j6y9sx3q0s">
                  <span className="k" style={{
                color: TONE[s.tone]
              }} data-id="element-438" data-mp="2r2m5ji84yrh4">
                    {s.code}
                  </span>
                  <span className="n" data-id="element-439" data-mp="amz7d3xferhv">{s.name}</span>
                </div>
                <span className="d" data-id="element-440" data-mp="akwlmw3b3kiy">{s.desc}</span>
              </div>)}
          </div>
          <div className="flow-arrow" aria-hidden="true" data-id="element-441" data-mp="ofyofacuwtrj">
            <svg width="120" height="80" viewBox="0 0 120 80" fill="none" stroke="#d4d1cd" strokeWidth="1.5" strokeLinecap="round" data-id="element-442" data-mp="kdtwcg224570">
              <path d="M8 12 C 60 12, 60 40, 112 40" data-id="element-443" data-mp="3sugczd0ud7x8" />
              <path d="M8 40 L 112 40" data-id="element-444" data-mp="3nuascgszolon" />
              <path d="M8 68 C 60 68, 60 40, 112 40" data-id="element-445" data-mp="3nvc4yppnlg8h" />
              <path d="M104 34 L 112 40 L 104 46" stroke="#1a1917" data-id="element-446" data-mp="5nwcudf2o3o5" />
            </svg>
          </div>
          <div className="libcard" data-id="element-447" data-mp="ni5yyp7izrp">
            <div className="top" data-id="element-448" data-mp="n8grdbzkwn2">
              <span style={{
              letterSpacing: '.12em'
            }} data-id="element-449" data-mp="1h2jgkd15p9w5">YOUR LIBRARY</span>
              <span style={{
              letterSpacing: '.04em',
              color: 'var(--green)'
            }} data-id="element-450" data-mp="1h4merkcgq9by">growing</span>
            </div>
            <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4
          }} data-id="element-451" data-mp="27dwkenfrlaxc">
              <div className="big" data-id="element-452" data-mp="27fzky1ejmmgb">{LIBRARY_TOTAL}</div>
              <div className="cap" data-id="element-453" data-mp="2cc6jh94m0vo8">governed instructions, each with an owner, a version, and a trigger</div>
            </div>
            <div className="q" data-id="element-454" data-mp="2hahrrff9ay4c">
              {LIBRARY_SPLIT.map(x => <div key={x.k} data-id="element-455" data-mp="2mc72sv2hbbsf">
                  <div className="k" data-id="element-456" data-mp="2mcgvwritlz2c">{x.k}</div>
                  <div className="v" data-id="element-457" data-mp="2qdakzo801jwt">{x.v}</div>
                </div>)}
            </div>
            <div className="ft" data-id="element-458" data-mp="2vbc4ga9c7l8t">
              <span data-id="element-459" data-mp="2va9aftgpx2oo">stays inside your walls</span>
              <span style={{
              color: 'var(--line-2)'
            }} data-id="element-460" data-mp="302u48uzmjfs7">·</span>
              <span data-id="element-461" data-mp="303c4s3tbkg5x">trains nothing but yours</span>
            </div>
          </div>
        </div>

        <div className="cols own" data-id="element-462" data-mp="350vin2m3uqxc">
          {OWNERSHIP.map(c => <div className="col" key={c.t} data-id="element-463" data-mp="3a1rr7thej193">
              <div className="col-t" data-id="element-464" data-mp="39yx4fvax14ci">{c.t}</div>
              <div className="col-b" data-id="element-465" data-mp="3e3d6tmlbltmz">{c.b}</div>
            </div>)}
        </div>
      </Section>

      <Section n="04" label="Attention loss" className="gridpaper bleed loss" data-id="element-466" data-mp="12frkwu7s3kdr">
        <p className="big" data-id="element-467" data-mp="yd4zpc5m4xpj">At high instruction density, the best frontier model missed nearly one in three instructions.</p>
        <p className="sub" data-id="element-468" data-mp="tf36vzidxk0v">It won’t tell you which. A wrong answer reads exactly like a right one.</p>
        <p className="cite" data-id="element-469" data-mp="ogrvvlgct3h2">
          <a href="https://arxiv.org/abs/2507.11538" target="_blank" rel="noopener" data-id="element-470" data-mp="ohjs8yhrz58e">
            IFScale, “How Many Instructions Can LLMs Follow at Once?”
          </a>{' '}
          · 68% adherence at high density
        </p>
      </Section>

      <Section n="05" label="What changes" className="changes" data-id="element-471" data-mp="1cce31b8pzxc3">
        <h2 className="h2" data-id="element-472" data-mp="17e2ur4y2puvz">Right the first time, with receipts.</h2>
        <div className="cols" data-id="element-473" data-mp="17dt2tbtgxdnn">
          {CHANGES.map(c => <div className="col" key={c.t} data-id="element-474" data-mp="24tqfacfezef7">
              <div className="t" data-id="element-475" data-mp="24vjonzhewcqw">{c.t}</div>
              <div className="b" data-id="element-476" data-mp="2028j01oc620k">{c.b}</div>
            </div>)}
        </div>
      </Section>

      <Section n="06" label="Who it’s for" className="who" data-id="element-477" data-mp="3uac92hz13j06">
        <div className="hgroup" data-id="element-478" data-mp="3ucygmhlx5yie">
          <h2 className="h2" style={{
          maxWidth: 900
        }} data-id="element-479" data-mp="27bgibz11e87">
            Regulated work. Real consequences.
          </h2>
          <p className="lede" data-id="element-480" data-mp="3kjq2ted7c4u5">
            Ask an AI the capital of France and there’s nothing to govern. The moment it drafts the denial, answers the regulator, or
            releases the payment, its output stops describing your business and starts <strong data-id="element-481" data-mp="3aopmi20tfig9">committing</strong> it.
          </p>
        </div>
        <div className="cols" style={{
        ['--n' as string]: 4
      }} data-id="element-482" data-mp="3fmhjhagbhurb">
          {WHO_FOR.map(w => <div className="col" key={w.t} data-id="element-483" data-mp="31n88qqavrsuq">
              <div className="t" data-id="element-484" data-mp="36l045uaqhx3o">{w.t}</div>
              <div className="b" data-id="element-485" data-mp="36lt163jw588m">{w.b}</div>
              <div className="tag" data-id="element-486" data-mp="36muob6e6ll6p">{w.tag}</div>
            </div>)}
        </div>
      </Section>

      <Section n="07" label="Proof" className="trust" data-id="element-487" data-mp="14tmyv44utn73">
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16
      }} data-id="element-488" data-mp="14sbtizvrg7dv">
          <div className="eyebrow" data-id="element-489" data-mp="1ewsdo5g9wanh">WORKS WITH</div>
          <div data-id="element-490" data-mp="1evh41p05c8og">
            {BRAND_ROWS.map((row, r) => <div className={`brands${r === 0 ? ' first' : ''}`} key={r} data-id="element-491" data-mp="19zs43kk7sprm" data-mpi={r}>
                {row.map(b => b.file ? <div className="brand" key={b.name} data-id="element-492" data-mp="1nrq85gz2jvgx">
                      <img src={asset(b.file)} alt={b.hideName ? b.name : ''} style={b.tall ? {
                height: 34
              } : undefined} data-id="element-493" data-mp="1iydjx7yaxqop" />
                      {!b.hideName && <span data-id="element-494" data-mp="1xpw7bqthqni3">{b.name}</span>}
                    </div> : <div className="brand wm" key={b.name} data-id="element-495" data-mp="1sr2s9tyk2oft">
                      {b.name}
                    </div>)}
              </div>)}
          </div>
        </div>
        <div className="cols" data-id="element-496" data-mp="caqh0oogjmoh">
          {TRUST.map(t => <div className="col" key={t.k} data-id="element-497" data-mp="cb8iq0tw2t3s">
              <div className="eyebrow" style={{
            fontSize: 12
          }} data-id="element-498" data-mp="89ely3mte98w">
                {t.k}
              </div>
              <div className="t" data-id="element-499" data-mp="wul8wb56q8pt">
                {t.t.split('\n').map((line, i) => <React.Fragment key={i} data-id="element-500" data-mp="11swiqlvhcj81" data-mpi={i}>
                    {i > 0 && <br data-id="element-501" data-mp="11rlfqo9uzfhz" />}
                    {line}
                  </React.Fragment>)}
              </div>
              <div className="b" data-id="element-502" data-mp="16m8uhvf28vjd">{t.b}</div>
            </div>)}
        </div>
      </Section>

      <StartHere n="08" data-id="element-503" data-mp="1anau4dcw39lv" />
    </>;
}